import { EntityType } from '@frontend/common';
import { Spinner } from '@frontend/components/common';
import { EquipmentExtendedClient } from '@frontend/equipment/api';
import { equipmentRequest } from '@frontend/equipment/events';
import { EquipmentExtended, IEquipment } from '@frontend/equipment/types';
import { CommonMessage } from '@frontend/lang';
import React from 'react';

import { ReactiveDetailRegistryEntry, ReactiveDetailView } from '../../modal/reactive-detail-shell/reactive-detail.types';
import {
    EQUIPMENT_CERTIFICATES_LABEL,
    EquipmentCertificatesSection,
    EquipmentConstraintsSection,
    EquipmentDetailsCard,
    EquipmentGeneralSection,
    LaundryEquipmentDetailsCard,
    isLaundryEquipmentContext
} from './equipment-detail-sections';

export const equipmentReactiveDetail: ReactiveDetailRegistryEntry<IEquipment, EquipmentExtended> = {
    entityType: EntityType.EQUIPMENT,
    resolveFunction: equipmentRequest,
    fetchExtended: ({ object, context }) => {
        if (isLaundryEquipmentContext(context)) {
            return Promise.resolve(object as EquipmentExtended);
        }
        return EquipmentExtendedClient.fetchEquipmentExtended(object.account_id, object.id);
    },
    modalClassName: 'w-full lg:w-2/3 max-w-[900px]',
    title: ({ object, context }) =>
        isLaundryEquipmentContext(context) ? (
            <>
                {CommonMessage.OBJECTS.COMMON_FIELDS.ITEM}: {object.serial_number}
            </>
        ) : (
            <>
                {CommonMessage.OBJECTS.EQUIPMENT.DEFAULT}: {object.serial_number}
            </>
        ),
    tabs: [
        {
            id: 'general',
            label: CommonMessage.DETAIL.GENERAL,
            render: (view) => {
                if (isLaundryEquipmentContext(view.context)) {
                    return <LaundryEquipmentDetailsCard equipment={view.object} />;
                }
                if (!view.extended) {
                    return (
                        <div className='flex w-full justify-center p-6'>
                            <Spinner className='text-border-default fill-brand-primary size-14' />
                        </div>
                    );
                }
                return (
                    <>
                        <EquipmentDetailsCard equipment={view.extended} />
                        <EquipmentGeneralSection equipment={view.extended} />
                    </>
                );
            }
        },
        {
            id: 'certificates',
            label: EQUIPMENT_CERTIFICATES_LABEL,
            visible: (view) => !isLaundryEquipmentContext(view.context),
            render: (view) => (view.extended ? <EquipmentCertificatesSection equipment={view.extended} /> : null)
        },
        {
            id: 'constraints',
            label: CommonMessage.OBJECTS.CONSTRAINT.PLURAL,
            visible: (view) => !isLaundryEquipmentContext(view.context),
            render: (view) => (view.extended ? <EquipmentConstraintsSection equipment={view.extended} /> : null)
        }
    ]
};

export type EquipmentReactiveView = ReactiveDetailView<IEquipment, EquipmentExtended>;
